import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import MovieCard from './MovieCard';

const ContentRow = ({ title, movies, onMovieClick, isModalOpen = false }) => {
  const rowRef = useRef(null);

  const scroll = (direction) => {
    const { current } = rowRef;
    if (current) {
      const scrollAmount = 400;
      current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  // Detect if this is the "Dernières vidéos publiées" row
  const isLatestVideosRow = title?.toLowerCase().includes('dernières vidéos publiées');
  return (
    <div className="px-6 md:px-12 mb-8 group overflow-visible">
      {/* Section Title */}
      <h2 className="text-white text-xl md:text-2xl font-semibold mb-4 hover:text-gray-300 transition-colors cursor-pointer">
        {title}
      </h2>

      {/* Slider Container */}
      <div className="relative overflow-visible">
        {/* Left Arrow */}
        <Button
          variant="ghost"
          className="absolute left-0 top-0 bottom-0 z-10 w-12 h-full bg-black/50 hover:bg-black/80 text-white rounded-none opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
          onClick={() => scroll('left')}
        >
          <ChevronLeft className="w-6 h-6" />
        </Button>

        {/* Right Arrow */}
        <Button
          variant="ghost"
          className="absolute right-0 top-0 bottom-0 z-10 w-12 h-full bg-black/50 hover:bg-black/80 text-white rounded-none opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
          onClick={() => scroll('right')}
        >
          <ChevronRight className="w-6 h-6" />
        </Button>

        {/* Movies Scroll Container */}
        <div 
          ref={rowRef}
          className="flex space-x-4 py-4 overflow-x-scroll overflow-y-visible"
          style={{ 
            scrollbarWidth: 'none', 
            msOverflowStyle: 'none'
          }}
        >
          {movies?.map((movie, index) => (
            <MovieCard 
              key={movie.id} 
              movie={movie} 
              index={index}
              onMovieClick={onMovieClick}
              isModalOpen={isModalOpen}
              labelWatermark={isLatestVideosRow ? (movie.label || movie.channelTitle || movie.artist || '') : undefined}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentRow;